import * as React from "react";
import { Box, Typography } from "@mui/material";
import {
  AccountTree as GraphNodeIcon,
  Build as ToolCallIcon,
  CheckCircle as ToolResultIcon,
  Psychology as ThinkingIcon,
  Sync as ToolCallDeltaIcon,
  AutoAwesome as ThinkingDeltaIcon,
  Hub as DefaultIcon,
} from "@mui/icons-material";
import type { TransientEvent, SSEEventType } from "../../types";

interface TransientEventsDisplayProps {
  events: TransientEvent[];
}

// Funzione per ottenere l'icona in base al tipo di evento
function getEventIcon(eventType: SSEEventType) {
  switch (eventType) {
    case "GraphNode":
      return GraphNodeIcon;
    case "FunctionToolCallEvent":
    case "PartStartEventToolCall":
      return ToolCallIcon;
    case "FunctionToolResultEvent":
      return ToolResultIcon;
    case "PartStartEventThinking":
      return ThinkingIcon;
    case "ToolCallPartDelta":
      return ToolCallDeltaIcon;
    case "ThinkingPartDelta":
      return ThinkingDeltaIcon;
    default:
      return DefaultIcon;
  }
}

export const TransientEventsDisplay: React.FC<TransientEventsDisplayProps> = ({
  events,
}) => {
  if (events.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        py: 1,
      }}
    >
      {events.map((event, index) => {
        const IconComponent = getEventIcon(event.type);

        return (
          <Box
            key={event.id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              opacity: 0.4 + (index / events.length) * 0.6,
              animation: "fadeIn 0.3s ease-in",
              "@keyframes fadeIn": {
                from: { opacity: 0 },
                to: { opacity: 0.4 + (index / events.length) * 0.6 },
              },
            }}
          >
            <IconComponent
              sx={{
                fontSize: 14,
                color: "text.secondary",
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontSize: "0.75rem",
              }}
            >
              {event.label}
            </Typography>
            {event.detail && (
              <Typography
                variant="caption"
                sx={{
                  color: "text.disabled",
                  fontSize: "0.7rem",
                  ml: 1,
                }}
              >
                {event.detail}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

